<template>
    <div>
        LandingPageInternal Dummy
    </div>
    <topicEntry></topicEntry>
</template>
<script>
    //import topicEntry from './TopicEntry.vue'
    export default {

        name: 'LandingPageInternal',
        components: {
            //topicEntry
        },
        data() {
            return {
            }
        },
        mounted() {
        },
        computed: {
        },
        methods: {
        }
    }
</script>
<style scoped>
</style>